import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainSection() {
  const pains = ['Domingo planificando cuando podrías descansar', 'Informes trimestrales que te llevan noches enteras', 'Actos preparados a último momento con improvisación', 'Evaluaciones sin criterio claro ni rúbricas listas', 'Material de aula desprolijo por falta de tiempo', 'Planificaciones que rehacés cada año desde cero', 'El mismo ciclo agotador — el próximo año también'];
  return <section className="py-12 px-6 bg-nocheLight" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-197">
            ¿Cuántos domingos más vas a perder así?
          </h2>
          <p className="text-lg text-gray-300" data-id="element-198">
            Amás enseñar, pero terminás los domingos armando planificaciones a
            las 11 de la noche con material que "más o menos sirve".
            <br data-id="element-199" />
            <br data-id="element-200" />
            <span className="text-tealBrand font-semibold" data-id="element-201">
              No es falta de vocación. Es falta de un sistema.
            </span>
          </p>
        </motion.div>

        <div className="bg-petroleo rounded-2xl p-8 md:p-10 border border-naranja/30 shadow-xl" data-id="element-202">
          <ul className="space-y-4" data-id="element-203">
            {pains.map((pain, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3 text-gray-200" data-id="element-204">
                <X className="w-6 h-6 text-naranja shrink-0 mt-0.5" data-id="element-205" />
                <span className="text-lg" data-id="element-206">{pain}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-8" data-id="element-207">
          <h3 className="text-2xl font-bold text-white" data-id="element-208">
            ¿Y si este fuera el último domingo que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}